import { render, staticRenderFns } from "./AppointmentsMobile.vue?vue&type=template&id=8cfa8386&scoped=true&"
import script from "./AppointmentsMobile.vue?vue&type=script&lang=js&"
export * from "./AppointmentsMobile.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentsMobile.vue?vue&type=style&index=0&id=8cfa8386&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfa8386",
  null
  
)

export default component.exports